const IconsEnum = {
  ADD: "Add",
  ANONYMIZATION: "Anonymization",
  ASSISTANT: "Assistant",
  AR: "Augmented Reality",
  ATTACHDOCUMENT: "Attach Document",
  FOLDER: "Folder",
  CAMERA: "Camera",
  CHAT: "Chat",
  CLOSE: "Close",
  DELETE: "Delete",
  CLEARFILTER: "Clear Filter",
  DRAG: "Drag",
  EDIT: "Edit",
  EYE: "Eye",
  EXPORT: "Export",
  MEASUREMENTS: "Measurements",
  REDO: "Redo",
  RESIZE: "Resize",
  SHIELDCHECKED: "Shield Checked",
  UNDO: "Undo",
  CALENDAR: "Calendar",
  PERSONALINFORMATION: "Personal Information",
  PATIENTMORPHOLOGY: "Patient Morphology",
  MEDICALIMAGE: "Medical Image",
  CLINICALDATA: "Clinical Data",
  REPORTS: "Reports",
  ACTIVITYTRACKING: "Activity Tracking",
  PAINASSESSMENT: "Pain Assessment",
  SURVEYRESULTS: "Survey Results",
  ARROWUP: "Arrow Up",
  ARROWDOWN: "Arrow Down",
  AXIALPLANE: "Axial Plane",
  BODYBACK: "Body Back",
  BODYFRONT: "Body Front",
  BODYLAYERS: "Body Layers",
  BRIGHTNESS: "Brightness",
  COMPARE: "Compare",
  CONTACTFORM: "Contact Form",
  CORONALPLANE: "Coronal Plane",
  CROP: "Crop",
  DUPLICATE: "Duplicate",
  EMAIL: "Email",
  EXITFULLSCREEN: "Exit Fullscreen",
  EXPAND: "Expand",
  GOBACK: "Go Back",
  GRID: "Grid",
  HARDWARE: "Hardware",
  HIDE: "Hide",
  IMPORT: "Import",
  JOIN: "Join",
  LAYINGPOSITION: "Laying Position",
  LOCK: "Lock",
  UNLOCK: "Unlock",
  NEXT: "Next",
  OSTEOTOMYTOOL: "Osteotomy Tool",
  PATIENTINDICATORS: "Patient Indicators",
  PHONENUMBER: "Phone Number",
  PHOTO: "Photo",
  POSITION: "Position",
  PROFILE: "Profile",
  REFLECT: "Reflect",
  SAGITTALPLANE: "Sagittal Plane",
  SECURITY: "Security",
  SECURITYUNLOCKED: "Security Unlocked",
  SHOW: "Show",
  SITTINGPOSITION: "Sitting Position",
  VIDEOCHAT: "Video Chat",
  WEBSITE: "Website",
  DISTANCE: "Distance",
  DISTANCEGENERIC: "Distance Generic",
  DISTANCEHORIZONTAL: "Distance Horizontal",
  DISTANCEVERTICAL: "Distance Vertical",
  ANGLE: "Angle",
  LOGOUT: "Logout",
  ANGLEGENERIC: "Angle Generic",
  ANGLEHORIZONTAL: "Angle Horizontal",
  ANGLEVERTICAL: "Angle Vertical",
  ANGLEINNER: "Angle Inner",
  ANGLE4POINTS: "Angle 4 Points",
  ANGLECOMP: "Angle Comp",
  ANGLECOBB: "Angle COBB",
  ANGLEKYPHOSIS: "Angle KYPHOSIS",
  ANGLELORDOSIS: "Angle LORDOSIS",
  OSTEOTOMIES: "Osteotomies",
  RODS: "Rods",
  CONFIRM: "Confirm",
  ADDVERTEBRA: "Add Vertebra",
  REMOVEVERTEBRA: "Remove Vertebra",
  ADDLANDMARK: "Add Landmark",
  INFO: "Info",
  SPONDY: "Spondy",
  CAGES: "Cages",
  DOLLFRONT: "Doll Front",
  DOLLVERIFIED: "Doll Verified",
  HISTORY: "History",
  HELP: "Help",
  DOCUMENTATION: "Documentation",
  SUPPORT: "Support",
  VIDEO: "Video",
  DATAFUSION: "Data Fusion",
  MODALITYSYNC: "Modality Sync",
  SPP: "Spp",
  THREE_D: "3D",
  RADIODENSITY: "Radiodensity",
  DECOMPENSATION: "Decompensation",
  FAVORITE: "Favorite",
  COMPAREDIGITALTWIN: "Compare Digital Twin",
  RESET: "Reset",
  SETTINGS: "Settings",
  RODLEFTENABLED: "Rod Left Enabled",
  RODLEFTDISABLED: "Rod Left Disabled",
  RODRIGHTENABLED: "Rod Right Enabled",
  RODRIGHTDISABLED: "Rod Right Disabled",
  RESETVIEW: "Reset View",
  PEN: "Pen",
  BRUSH: "Brush",
  ERASER: "Eraser",
  CIRCLE: "Circle",
  SQUARE: "Square",
  CEMARKUDI: "CE Mark UDI",
  CEMARKWARMING: "CE Mark Warning",
  CEMARKMANUFACTURER: "CE Mark Manufacturer",
  CEMARKMEDICALDEVICE: "CE Mark Medical Device",
  CEMARKNOTIFIEDBODY: "CE Mark Notified Body",
  CEMARKBOOKINFO: "CE Mark Book Info",
  SPINE: "Spine",
  DOWNLOAD: "Download",
  UPLOAD: "Upload",
};

export default IconsEnum;
